import React from "react";

export const SearchResult = ({ PageName, PageSummary, PageUrl, Id }) => {
    const createMarkup = (content) => {
        return { __html: content };
    };

    return (
        <div id={Id}>
            <p>
                <a href={PageUrl} class="no-underline hover:underline">
                    {PageName}
                </a>

                <div
                    class="search-result-summary mt-2"
                    dangerouslySetInnerHTML={createMarkup(PageSummary)}
                ></div>
            </p>

            <hr class="my-4" />
        </div>
    );
};
